import React, { useState, useEffect } from 'react'
import './Assets/css/style.css'
import SocialMedia from './Assets/Image/social_media_group.svg'
import Logo from './Assets/Image/logo.svg'
import HeroImage from './Assets/Image/hero_image.svg'
// import Lottie from 'react-lottie-player'
import Hustle from './Assets/Image/hustle_1.svg'
import Hustle2 from './Assets/Image/hustle_2.svg'
import CharmCircle from './Assets/Image/charm_circle-tick.svg'
import Allinone from './Assets/Image/allinone_4.svg'
import Allinone5 from './Assets/Image/allinone_5.svg'
import heroImageBotton from './Assets/Image/hero_image_bottom.svg'
import allinoneone11 from './Assets/Image/allinone_1.svg'
import allinoneone22 from './Assets/Image/allinone_2.svg'
import allinone from './Assets/Image/allinone_3.svg'
import ReactGA from 'react-ga'

// import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'

import { useFormik, setFieldValue } from 'formik'
import firebase from './Firebase'
import * as yup from 'yup'
import TagManager from 'react-gtm-module'
import useAnalyticsEventTracker from './trackers/useAnalyticsEventTracker'

function MyVerticallyCenteredModal (props) {
  return (
    <Modal
      {...props}
      size='lg'
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      {/* <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Modal heading
        </Modal.Title>
      </Modal.Header> */}
      <Modal.Body>
        <h2 className='f-20 mb-1 primary_color highlighter'>Thank you for submission</h2>

        <p className='f-14 secondory_color'>We reach out to you soon once beta released.</p>
        <button className='btn close_btn mt-2' onClick={props.onHide}>Close</button>

        <div className='modal fade' id='myModal'>
          <div className='modal-dialog modal-dialog-centered'>
            <div className='modal-content'>
              <div className='text-center p-4'>
                <div className='text-center mx-auto'>
                  {/* <Lottie
      loop
      animationData={"https://assets1.lottiefiles.com/packages/lf20_pblicwjs.json"}
      play
      style={{ width: 150, height: 150 }}
    />
     */}
                  {/* <lottie-player src="https://assets1.lottiefiles.com/packages/lf20_pblicwjs.json" background="transparent" speed={1} style={{width: 150, height: 150, margin: 'auto'}} loop autoPlay />
             */}
                </div>
                <h2 className='f-20 mb-1 primary_color highlighter'>Thank you for submission</h2>
                <p className='f-14 secondory_color'>We reach out to you soon once beta released.</p>
                <button className='btn close_btn mt-2' onClick={props.onHide}>Close</button>
              </div>
            </div>
          </div>
        </div>
        {/* <h4>Centered Modal</h4>
        <p>
          Cras mattis consectetur purus sit amet fermentum. Cras justo odio,
          dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac
          consectetur ac, vestibulum at eros.
        </p> */}
      </Modal.Body>
      {/* <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer>  */}
    </Modal>
  )
}

const App = () => {
  const [show, setShow] = useState(false)
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const initialValues = {
    first_name: ''
  }

  const TRACKING_ID = 'UA-241374955-1'
  ReactGA.initialize(TRACKING_ID)

  const gaEventTracker = useAnalyticsEventTracker('Contact us')

  const tagManagerArgs = {
    gtmId: 'GTM-N2NQZBG',
    dataLayer: {
      userId: '001',
      userProject: 'costan home page'
    }
  }
  TagManager.initialize(tagManagerArgs)

  useEffect(() => {
    TagManager.dataLayer(tagManagerArgs)
  }, [])

  const [modalShow, setModalShow] = React.useState(false)

  const validationSchema = yup.object({
    first_name: yup.string().required('Required')

  })

  const onSubmit = () => {
    gaEventTracker('onSubmit without collecting Data')
    ReactGA.event({ category: 'etst', action: 'submit empty', label: 'label' })
    // setCheckoutForm();

    console.log('final form value', formic.values)

    firebase.firestore().collection('email')
      .doc()
      .set({
        email: formic.values.first_name
      }).then(() => {
        gaEventTracker(formic.values.first_name)
        ReactGA.event({ category: 'submitted', action: 'submit email', label: 'label2' })

        formic.values.first_name = ''
        ReactGA.event({ category: 'etst2', action: 'submit empty2', label: 'label2' })
        setModalShow(true)
      })
  }

  const formic = useFormik({
    initialValues,
    onSubmit,
    validationSchema

  })

  return (
    <div>

      <div className='modal fade' id='myModal'>
        <div className='modal-dialog modal-dialog-centered'>
          <div className='modal-content'>
            <div className='text-center p-4'>
              <div className='text-center mx-auto'>
                {/* <Lottie
      loop
      animationData={"https://assets1.lottiefiles.com/packages/lf20_pblicwjs.json"}
      play
      style={{ width: 150, height: 150 }}
    />
     */}
                {/* <lottie-player src="https://assets1.lottiefiles.com/packages/lf20_pblicwjs.json" background="transparent" speed={1} style={{width: 150, height: 150, margin: 'auto'}} loop autoPlay />
             */}
              </div>
              <h2 className='f-20 mb-1 primary_color highlighter'>Thank you for submission</h2>
              <p className='f-14 secondory_color'>We reach out to you soon once beta released.</p>
              <button className='btn close_btn mt-2' data-bs-dismiss='modal'>Close</button>
            </div>
          </div>
        </div>
      </div>

      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />

      <header className='py-3'>
        <nav className='navbar navbar-expand-lg navbar-light topnavigation'>
          <div className='container-fluid'>
            <a className='navbar-brand float-left'>
              <img className='img-fluid' src={Logo} alt />
            </a>
            <div className='float-right'>
              <button className='btn blue_btn'>BETA COMING SOON</button>
            </div>
          </div>
        </nav>
      </header>
      <div className='container-fluid mt-3'>
        <section className='hero_image'>
          <img className='hero_display d-none d-xl-block' src={HeroImage} />
          <div className='hero_text text-center py-5'>
            <div className='row'>
              <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mx-auto'>
                <h1 className='highlighter primary_color f-50'>One stop solution to all <br /> <span className='blue_text'>Content creators</span> 📝</h1>
                <p className='secondory_color f-14 mt-3 px-3'>Costan is the next-generation tool for content creators or influencers.</p>
              </div>
              <div className='mt-5'>
                <img className='w-80' src={SocialMedia} />
              </div>
              <form className='form-inline w-90 mx-auto' onSubmit={formic.handleSubmit}>
                <div className='input-container'>
                  <input
                    type='email'
                    name='first_name'
                    onChange={formic.handleChange}
                    value={formic.values.first_name}
                    onBlur={formic.handleBlur}
                    placeholder='Email Address' className='input-field'
                  />
                  <button
                    className='input-button btn blue_btn my-sm-0 f-12' type='submit'
                  >NOTIFY ME
                  </button>
                </div>
              </form>
            </div>
          </div>
        </section>
        <div className='row mt-5 mx-auto text-center'>
          <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
            <h1 className='highlighter my-5 primary_color f-50'>Manage your content hustle free</h1>
          </div>
          <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mx-auto text-center mt-3'>
            <p className='text-center'><b>WITHOUT COSTAN</b></p>
            <p className='text-center secondory_color'>Hustle manage content across platforms, You are use multiple tools for<br /> that made preventing rework and miscommunication.</p>//
            <img className='img-fluid' src={Hustle} />
          </div>
          <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mx-auto text-center mt-3'>
            <p className='text-center'><b>WITH COSTAN</b></p>
            <p className='text-center secondory_color'>Manage your content by offering you and your team all in one one tool.<br />Easy collaboration keeps everyone in the loop.</p>
            <img className='img-fluid' src={Hustle2} alt='hustle' />
          </div>
        </div>
        <div className='row mt-5'>
          <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
            <h1 className='highlighter my-5 primary_color f-50 text-center'><span className='blue_text'>Your workplace</span> <br />We build for creators who want to grow 📈 </h1>
          </div>
          <div className='row my-5 d-flex align-item-center justify-content-middle'>
            <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-3'>
              <h1 className='highlighter'>Plan out content </h1>
              <p className='secondory_color my-3'>Plan is bring ideas into content creation to all preparation before record like goal, target audience, platform, date of recording to publish.</p>
              <div className='d-flex align-item-center justify-content-middle my-4'>
                <img className='img-fluid' src={CharmCircle} alt='' /> <div className='ms-3'><b>Create weekly and monthly content plan</b></div>
              </div>
              <div className='d-flex align-item-center justify-content-middle my-4'>
                <img className='img-fluid' src={CharmCircle} alt='' /> <div className='ms-3'><b>Assign roles to your teammates</b></div>
              </div>
              <div className='d-flex align-item-center justify-content-middle my-4'>
                <img className='img-fluid' src={CharmCircle} alt='' /> <div className='ms-3'><b>Create a goal for your content</b></div>
              </div>
            </div>
            <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-3 d-flex '>
              <img className='img-fluid' src={allinoneone11} alt='allionone ' />
            </div>
          </div>
          <div className=' row my-5 d-flex align-item-center justify-content-middle'>
            <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-3 d-flex d-none d-md-block'>
              <img className='img-fluid' src={allinoneone22} alt='allionone ' />
            </div>
            <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-3'>
              <h1 className='highlighter'>Script and record</h1>
              <p className='secondory_color my-3'>The content idea is translated into a script and shot. The recorded shot is imported and exported via a plugin from the editing tool. </p>
              <div className='d-flex align-item-center justify-content-middle my-4'>
                <img className='img-fluid' src={CharmCircle} alt='' /> <div className='ms-3'><b>Timestamp script writing</b></div>
              </div>
              <div className='d-flex align-item-center justify-content-middle my-4'>
                <img className='img-fluid' src={CharmCircle} alt='' /> <div className='ms-3'><b>Manage your recording and shot</b></div>
              </div>
              <div className='d-flex align-item-center justify-content-middle my-4'>
                <img className='img-fluid' src={CharmCircle} alt='' /> <div className='ms-3'><b>Import and export via a plugin from the editing tool</b></div>
              </div>
            </div>
            <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-3 d-flex d-block d-md-none'>
              <img className='img-fluid' ssrc={allinoneone22} alt='allionone ' />
            </div>
          </div>
          <div className='row my-5 d-flex align-item-center justify-content-middle'>
            <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-3'>
              <h1 className='highlighter'>Review and approve</h1>
              <p className='secondory_color my-3'> Get feedback and approve when you need them—so you stay creative and productive. Instant updates are sent to all teammates via WhatsApp..</p>
              <div className='d-flex align-item-center justify-content-middle my-4'>
                <img className='img-fluid' src={CharmCircle} alt='' /> <div className='ms-3'><b>View feedback on a precise video frame or across a sequence</b></div>
              </div>
              <div className='d-flex align-item-center justify-content-middle my-4'>
                <img className='img-fluid' src={CharmCircle} alt='' /> <div className='ms-3'><b>Clearly illustrate your ideas with a simple drawing</b></div>
              </div>
              <div className='d-flex align-item-center justify-content-middle my-4'>
                <img className='img-fluid' src={CharmCircle} alt='' /> <div className='ms-3'><b>Get approvals in real time from anyone, anywhere</b></div>
              </div>
            </div>
            <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-3 d-flex '>
              <img className='img-fluid' src={allinone} alt='llion3' />
            </div>
          </div>
          <div className='row my-5 d-flex align-item-center justify-content-middle'>
            <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-3 d-flex d-none d-md-block'>
              <img className='img-fluid' src={Allinone} alt='allinone' />
            </div>
            <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-3'>
              <h1 className='highlighter'>Publish across channels</h1>
              <p className='secondory_color my-3'>Integrate all channel  and publish by one click on youtube, TikTok, Linkedin, Instagram and lot more.</p>
              <div className='d-flex align-item-center justify-content-middle my-4'>
                <img className='img-fluid' src={CharmCircle} alt='' /> <div className='ms-3'><b>Integrate channel</b></div>
              </div>
              <div className='d-flex align-item-center justify-content-middle my-4'>
                <img className='img-fluid' src={CharmCircle} alt='' /> <div className='ms-3'><b>Schedule your content</b></div>
              </div>
              <div className='d-flex align-item-center justify-content-middle my-4'>
                <img className='img-fluid' src={CharmCircle} alt='' /> <div className='ms-3'><b>Published across channels</b></div>
              </div>
            </div>
            <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-3 d-flex d-block d-md-none'>
              <img className='img-fluid' src={Allinone} alt='allinone' />
            </div>
          </div>
          <div className='row my-5 d-flex align-item-center justify-content-middle'>
            <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-3'>
              <h1 className='highlighter'>Analyze and insights</h1>
              <p className='secondory_color my-3'> Measure your content performance with recommendation insights in a few clicks.</p>
              <div className='d-flex align-item-center justify-content-middle my-4'>
                <img className='img-fluid' src={CharmCircle} alt='' /> <div className='ms-3'><b>Cross channel analyze</b></div>
              </div>
              <div className='d-flex align-item-center justify-content-middle my-4'>
                <img className='img-fluid' src={CharmCircle} alt='' /> <div className='ms-3'><b>Recommended insights</b></div>
              </div>
              <div className='d-flex align-item-center justify-content-middle my-4'>
                <img className='img-fluid' src={CharmCircle} alt='' /> <div className='ms-3'><b>Target achieve alert</b></div>
              </div>
            </div>
            <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-3 d-flex '>
              <img className='img-fluid' src={Allinone5} alt='allinone5' />
            </div>
          </div>
        </div>
        <section className='hero_image_bottom mt-5 py-5'>
          <div className='container'><img className='hero_display img-fluid d-none d-xl-block' src={heroImageBotton} alt='allinone5' /></div>
          <div className='hero_text text-center'>
            <div className='row'>
              <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mx-auto'>
                <h1 className='highlighter primary_color f-50 px-3'>Your fastest path to create more engaging content.</h1>
                <p className='secondory_color f-14 mt-3 px-3'>To get early access to the beta release, enter your email address below!</p>
              </div>
              <form className='form-inline w-90 mx-auto' onSubmit={formic.handleSubmit}>
                <div className='input-container'>
                  <input
                    name='first_name'
                    onChange={formic.handleChange}
                    value={formic.values.first_name}
                    onBlur={formic.handleBlur}

                    placeholder='Email Address' className='input-field'
                  />
                  <button
                    className='input-button btn blue_btn my-sm-0 f-12' type='submit'
                  >NOTIFY ME
                  </button>
                </div>
              </form>
            </div>
          </div>
        </section>
        <footer>
          <div className='row my-4'>
            <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mx-auto'>
              <div className='contact_details'>
                <p className='secondory_color'><b>Say hello vijay@costan.in <br /> @Costan2022</b></p>
              </div>
            </div>
            <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mx-auto'>
              <div className='social_media_links'>
                <ul className>
                  <li><a href='https://www.facebook.com/costandotin'><i className='fa-brands secondory_color fa-facebook-square fb' /></a></li>
                  <li><a href='https://www.linkedin.com/company/costan/'><i className='fa-brands secondory_color fa-linkedin linkedin' /></a></li>
                  <li><a href='https://www.instagram.com/costan.in/'><i className='fa-brands secondory_color fa-instagram insta' /></a></li>
                  <li><a href='https://twitter.com/costandotin'><i className='fa-brands secondory_color fa-twitter twitter' /></a></li>
                </ul>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>

  )
}

export default App
